import React from "react";
import { isNil } from "ramda";
import Plot from "react-plotly.js";

const WaterfallChart = ({ prefix, data, intl }) => {
  const HeatMap = () => {
    const heatMapData = data?.series?.map((s) => ({
      ...s,
    }));
    const scale = data?.graphic?.charAt(0).toUpperCase() + data?.graphic?.slice(1);
    if (isNil(heatMapData)) {
      return null;
    }
    const layout = {
      title: data.title,
      xaxis: {
        title: { text: data.xAxis.text, standoff: 10 },
        type: data.xAxis.type,
        tickformatstops:
          data.xAxis.type === "date"
            ? [
                {
                  dtickrange: [null, "D1"], // alejado → días
                  value: "%Y/%m/%d",
                },
                {
                  dtickrange: ["D1", "h1"], // acercando → horas
                  value: "%Y/%m/%d %Hh",
                },
                {
                  dtickrange: ["h1", null], // zoom fuerte → minutos
                  value: "%Y/%m/%d %H:%M",
                },
              ]
            : null,
        tickangle: 0,
        automargin: true,
      },
      yaxis: {
        title: {
          text: data.yAxis.text,
          standoff: 10,
        },
        type: data.yAxis.type,
        tickformatstops:
          data.yAxis.type === "date"
            ? [
                {
                  dtickrange: [null, "D1"], // alejado → días
                  value: "%Y/%m/%d",
                },
                {
                  dtickrange: ["D1", "h1"], // acercando → horas
                  value: "%Y/%m/%d %Hh",
                },
                {
                  dtickrange: ["h1", null], // zoom fuerte → minutos
                  value: "%Y/%m/%d %H:%M",
                },
              ]
            : null,
        automargin: true,
      },
      paper_bgcolor: "transparent",
      plot_bgcolor: "transparent",
      margin: { l: 0, r: 0, t: 25, b: 0 },
    };
    return (
      <Plot
        data={[
          {
            z: heatMapData[0].data,
            x: data.xAxis.data,
            y: data.yAxis.data,
            type: "heatmap",
            colorscale: scale,
            zmin: data.limits.min, // mínimo valor permitido
            zmax: data.limits.max, // máximo valor permitido
          },
        ]}
        layout={layout}
        style={{ width: "100%", height: "500px" }}
      />
    );
  };
  return (
    <div style={{ overflow: "hidden" }}>
      <HeatMap />
    </div>
  );
};

export default WaterfallChart;
